module.exports = __webpack_public_path__ + "img/wholesaleIcon8.2769a427.png";